// The page's words (the shared page is @tol/ui/html).

import type { PageMeta } from '@tol/ui/html';

export const WORLD_PAGE: PageMeta = {
  title: 'Transit, live',
  description:
    'Live trains, trams, buses and ferries in cities and regions around the world, on one map. Zoom in on one to see them move.',
  emoji: '🚇',
  url: 'https://transitof.com/',
  // New York's trains on the map (public/og.jpg, a 1200x630 screenshot at
  // twice the pixels).
  image: {
    src: 'https://transitof.com/og.jpg',
    width: 2400,
    height: 1260,
    alt: 'A live map of Lower Manhattan and Brooklyn with trains moving on the subway lines',
  },
  // The site's one Plausible site, as the cities'.
  plausible: 'pa-xuLkhr-KcHbLw40I2AuRg',
  mapLabel: 'World map with live transit in the cities covered',
  footnote:
    'Solid markers are live: GPS where operators share it, otherwise estimated from live data. Hollow markers follow the timetable.',
  reportExample: 'A train jumped near Central…',
};
